import * as React from 'react';

import { cn } from '@rematter/ui-web';

export interface LineItemHeaderProps {
  gridTemplate: string;
  children: React.ReactNode;
  className?: string;
}

export const LineItemHeader: React.FC<LineItemHeaderProps> = ({
  gridTemplate,
  children,
  className,
}) => (
  <div
    className={cn(
      '@LineItemHeader grid gap-2 text-sm font-medium',
      gridTemplate,
      className,
    )}
  >
    {children}
  </div>
);

export interface HeaderCellProps {
  children?: React.ReactNode;
  className?: string;
}

export const HeaderCell: React.FC<HeaderCellProps> = ({
  children,
  className,
}) => (
  <div className={cn('@HeaderCell flex items-center justify-start', className)}>
    {children}
  </div>
);
